import { Row } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { SeasonalRule } from 'models/seasonality/SeasonalRule';
import { ColorDot, ColorCellStyled } from '../SeasonalRulesTable.styles';

const ColorCell = ({ row }: { row: Row<SeasonalRule> }) => {
  const { t } = useTranslation();
  const { color } = row.original;

  return (
    <ColorCellStyled>
      <ColorDot $color={color} />
      <span>{t(`pageProperty.seasonality.colors.${color}`)}</span>
    </ColorCellStyled>
  );
};

export default ColorCell;
